import { Link } from "react-router-dom";
import { cls } from "./Utility";

export default function Footer() {
  return (
    <>
      {/*only for desktop screens */}
      <div
        className={cls(
          "flex flex-col bg-[black] gap-[40px] p-[40px]",
          "xl:w-full xl:p-[60px] xl:bg-[black] xl:flex xl:flex-row xl:justify-center  xl:gap-[60px]"
        )}
      >
        <div className="flex flex-col xl:w-[250px] w-full">
          <p className="font-[Headings] text-[16px] text-[#828282] mb-[15px]">
            CONTACT
          </p>
          <p className="font-[description1] text-white text-[14px] mb-[10px]">
            +91 93536-24245
          </p>
          <p className="font-[description1] text-white text-[14px] mb-[10px]">
            <a href="mailto:hello@storiesbyrg.com">hello@storiesbyrg.com</a>
          </p>
          <p className="font-[description1] text-white text-[14px]">
            {" "}
            First Floor, No: 12/1-1, Palace Cross Road, Bangalore 560020
          </p>
        </div>

        <div className="flex flex-col xl:w-[200px] w-full">
          <p className="font-[Headings] text-[16px] text-[#828282] mb-[15px]">
            SOCIAL
          </p>
          <p className="font-[description1] text-white text-[14px] mb-[10px] hover:text-[#828282]">
            <a
              href="https://www.instagram.com/storiesby.rg/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Read more"
            >
              Instagram
            </a>
          </p>
          <p className="font-[description1] text-white text-[14px] mb-[10px] hover:text-[#828282]">
            <a
              href="https://www.youtube.com/channel/UCn9GaUS7TlcMtuPiZ-PuOLg"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Read more"
            >
              YouTube
            </a>
          </p>
          <p className="font-[description1] text-white text-[14px] mb-[10px] hover:text-[#828282]">
            <a
              href="https://www.facebook.com/storiesbyrg/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Read more"
            >
              Facebook
            </a>
          </p>
          <p className="font-[description1] text-white text-[14px] mb-[10px] hover:text-[#828282]">
            <a
              href="https://www.linkedin.com/company/stories-by-rg/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Read more"
            >
              LinkedIn
            </a>
          </p>
          <p className="font-[description1] text-white text-[14px] mb-[10px] hover:text-[#828282]">
            <a
              href="https://twitter.com/storiesbyrg"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Read more"
            >
              Twitter
            </a>
          </p>
        </div>

        <div className="flex flex-col xl:w-[200px] w-full">
          <p className="font-[Headings] text-[16px] text-[#828282] mb-[15px]">
            QUICK LINKS
          </p>
          {/* <a
            href="/about"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Read more"
          >
            {" "}
            <p className="font-[description1] text-white text-[14px] mb-[10px] hover:text-[#828282]">
              About
            </p>
          </a> */}
          <a
            href="/photography"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Read more"
          >
            {" "}
            <p className="font-[description1] text-white text-[14px] hover:text-[#828282] mb-[10px]">
              Photography
            </p>
          </a>
          <a
            href="/films"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Read more"
          >
            {" "}
            <p className="font-[description1] text-white text-[14px] mb-[10px] hover:text-[#828282]">
              Films
            </p>
          </a>
          <a
            href="/international-shoots"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Read more"
          >
            {" "}
            <p className="font-[description1] text-white text-[14px] mb-[10px] hover:text-[#828282]">
              International
            </p>
          </a>
          <a
            href="/connect"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Read more"
          >
            {" "}
            <p className="font-[description1] text-white text-[14px] mb-[10px] hover:text-[#828282]">
              Connect
            </p>
          </a>
        </div>

        <div className="flex flex-col xl:w-[200px] w-full">
          <p className="font-[Headings] text-[16px] text-[#828282] mb-[15px]  ">
            CORPORATE
          </p>{" "}
          <Link to="/terms-and-conditions">
            {" "}
            <p className="font-[description1] text-white text-[14px] mb-[10px] hover:text-[#828282]">
              Terms & Conditions
            </p>
          </Link>
          <Link to="/privacy-policy">
            <p className="font-[description1] text-white text-[14px] mb-[10px] hover:text-[#828282]">
              Privacy Policy
            </p>
          </Link>
          <Link to="/cancellation-and-refund">
            <p className="font-[description1] text-white text-[14px] hover:text-[#828282]">
              Cancellation & Refund
            </p>
          </Link>
        </div>
      </div>
    </>
  );
}
